import React from 'react';

import {connect} from 'react-redux';
import {compose} from 'redux';
import injectReducer from 'utils/injectReducer';

import {createStructuredSelector} from 'reselect';
import reducer from './reducer';
import {searchCustomerByFiscal, searchCustomerByVat, updateCustomerInput, resetCustomer} from './actions';
import {default as CustomerForm} from '../Quotation/form-customer';
import {
  makeSelectOfferSelector,
  makeSelectServicesSelector,
  makeSelectAccessoriesCodesSelector,
  makeSelectColorCodesSelector,
} from '../CustomizeOffer/selectors';
import {
  makeSelectCustomer,
  makeSelectCustomerFound,
  makeSelectCustomerUpdatedInput,
} from './selectors';

class CustomerFormWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  onInputChange = e => {
    const value = e.target.value;
    const name = e.target.name;
    this.props.updateCustomerInput(name, value);
  };

  render() {
    const {
      proposal,
      customer,
      customerUpdatedInput,
      customerFound,
      offer,
      services,
      accessories,
      colors,
      searchCustomerByFiscal,
      searchCustomerByVat,
      selectedAccessories,
      selectedColors,
      resetCustomer,
      prescoringData,
    } = this.props;
    let customerToRender = customerUpdatedInput;
    if (customerFound !== undefined) {
      customerToRender = customer;
      customerToRender = {
        ...customerToRender,
        notes: proposal.notes || '',
        ...customerUpdatedInput,
      };
      return (
        <CustomerForm
          proposal={proposal}
          prescoringData={prescoringData}
          customer={customerToRender}
          offer={offer}
          newMonthlyRate={proposal.newMonthlyRate}
          services={services}
          accessories={accessories}
          colors={colors}
          searchCustomerByFiscal={searchCustomerByFiscal}
          searchCustomerByVat={searchCustomerByVat}
          selectedAccessories={selectedAccessories}
          selectedColors={selectedColors}
          onInputChange={this.onInputChange}
          resetCustomer={resetCustomer}
          customerFound={customerFound}
        />
      );
    } else if (proposal.customer) {
      customerToRender = proposal.customer;
      customerToRender.employee_category = customerToRender.category.code;
      let notes = customerUpdatedInput.notes || proposal.notes;
      customerToRender = {
        ...customerToRender,
        ...customerUpdatedInput,
        notes,
      };
      return (
        <CustomerForm
          proposal={proposal}
          prescoringData={prescoringData}
          customer={customerToRender}
          offer={offer}
          newMonthlyRate={proposal.newMonthlyRate}
          services={services}
          accessories={accessories}
          colors={colors}
          searchCustomerByFiscal={searchCustomerByFiscal}
          searchCustomerByVat={searchCustomerByVat}
          selectedAccessories={selectedAccessories}
          selectedColors={selectedColors}
          onInputChange={this.onInputChange}
          resetCustomer={resetCustomer}
          customerFound={false}
        />
      );
    } else {
      customerToRender = {...customerToRender, notes: proposal.notes || ''};
      return (
        <CustomerForm
          proposal={proposal}
          prescoringData={prescoringData}
          customer={customerToRender}
          offer={offer}
          newMonthlyRate={proposal.newMonthlyRate}
          services={services}
          accessories={accessories}
          colors={colors}
          searchCustomerByFiscal={searchCustomerByFiscal}
          searchCustomerByVat={searchCustomerByVat}
          selectedAccessories={selectedAccessories}
          selectedColors={selectedColors}
          onInputChange={this.onInputChange}
          resetCustomer={resetCustomer}
          customerFound={false}
        />
      );
    }
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    searchCustomerByFiscal: (fiscalCode, contractualCategory, customer) => dispatch(searchCustomerByFiscal(fiscalCode, contractualCategory, customer)),
    searchCustomerByVat: (vatNumber, contractualCategory, customer) => dispatch(searchCustomerByVat(vatNumber, contractualCategory, customer)),
    updateCustomerInput: (field, value) => dispatch(updateCustomerInput(field, value)),
    resetCustomer: () => dispatch(resetCustomer()),
  };
}

const mapStateToProps = createStructuredSelector({
  customer: makeSelectCustomer(),
  customerFound: makeSelectCustomerFound(),
  customerUpdatedInput: makeSelectCustomerUpdatedInput(),
  offer: makeSelectOfferSelector(),
  services: makeSelectServicesSelector(),
  accessories: makeSelectAccessoriesCodesSelector(),
  colors: makeSelectColorCodesSelector(),
});

const withReducer = injectReducer({key: 'quote', reducer});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withConnect,
)(CustomerFormWrapper);
